<mat-stepper  [orientation]="isHandset ? 'vertical' : 'horizontal'" #stepper>

  <!-- Step 1: General Information -->
  <mat-step [stepControl]="generalInfoProjectDetailFormGroup">
    <ng-template matStepLabel>1. Podaci o programu/projektu</ng-template>
    @if (stepper.selectedIndex === 0) {
      <mat-card class="daxa-card mb-25 border-radius bg-white border-none d-block">
        <mat-card-header>
          <mat-card-title>
            <h5 class="mb-0">1. Podaci o programu/projektu</h5>
          </mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <form [formGroup]="generalInfoProjectDetailFormGroup">
            @for (field of [
              { label: 'Period izvještavanja - Početak', control: 'reportingPeriodStart', type: 'date' },
              { label: 'Period izvještavanja - Kraj', control: 'reportingPeriodEnd', type: 'date' },
              { label: 'Klasa ugovora', control: 'contractClass', type: 'text' },
              { label: 'Naziv organizacije', control: 'organizationName', type: 'text' },
              { label: 'Naziv programa/projekta', control: 'programName', type: 'text' },
              { label: 'Ovlaštena osoba', control: 'authorizedPerson', type: 'text' },
              { label: 'Voditelj programa/projekta', control: 'programManager', type: 'text' },
              { label: 'Mjesto provedbe', control: 'implementationLocation', type: 'text' },
              { label: 'Odobreni iznos', control: 'approvedAmount', type: 'number', config: { decimals: 2, useThousands: true, maxDigits: 10 } },
              { label: 'Utrošeni iznos', control: 'spentAmount', type: 'number', config: { decimals: 2, useThousands: true, maxDigits: 10 } }
              ]; track field) {
              <div>
                <div class="mb-25">
                  @if (field.type === 'text') {
                    <mat-form-field class="full-width">
                      <mat-label>{{ field.label }}</mat-label>
                      <input matInput [formControlName]="field.control" />
                    </mat-form-field>
                  }
                  @if (field.type === 'number') {
                    <mat-form-field class="full-width">
                      <mat-label>{{ field.label }}</mat-label>
                      <input matInput formattedNumber [config]="field.config" [formControlName]="field.control" />
                    </mat-form-field>
                  }
                  @if (field.type === 'date') {
                    <mat-form-field class="full-width">
                      <mat-label>{{ field.label }}</mat-label>
                      <input matInput [matDatepicker]="picker" [formControlName]="field.control">
                      <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                      <mat-datepicker #picker></mat-datepicker>
                    </mat-form-field>
                  }
                </div>
              </div>
            }
            <div>
              <button mat-flat-button matStepperNext class="daxa" [disabled]="generalInfoProjectDetailFormGroup.invalid">Dalje</button>
            </div>
          </form>
        </mat-card-content>
      </mat-card>
    }
  </mat-step>


  <!-- Step 2: Contact Details -->
  <mat-step [stepControl]="generalInfoContactDetailFormGroup">
    <ng-template matStepLabel>1.1 Kontaktni podaci</ng-template>
    @if (stepper.selectedIndex === 1) {
      <mat-card class="daxa-card mb-25 border-radius bg-white border-none d-block">
        <mat-card-header>
          <mat-card-title>
            <h5 class="mb-0">1.1 Kontaktni podaci</h5>
          </mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <form [formGroup]="generalInfoContactDetailFormGroup">
            @for (field of [
              { label: 'Adresa organizacije', control: 'organizationAddress', type: 'text' },
              { label: 'Telefon organizacije', control: 'organizationPhone', type: 'text' },
              { label: 'Fax organizacije', control: 'organizationFax', type: 'text' },
              { label: 'Odgovorna osoba za kontakt', control: 'contactPerson', type: 'text' },
              { label: 'Telefon odgovorne osobe', control: 'contactPhone', type: 'text' },
              { label: 'Email odgovorne osobe', control: 'contactEmail', type: 'text' },
              { label: 'Internetska stranica', control: 'website', type: 'text' }
              ]; track field) {
              <div>
                <div class="mb-25">
                  @if (field.type === 'text') {
                    <mat-form-field class="full-width">
                      <mat-label>{{ field.label }}</mat-label>
                      <input matInput [formControlName]="field.control" />
                    </mat-form-field>
                  }
                </div>
              </div>
            }
            <div>
              <button mat-flat-button matStepperPrevious class="mr-15">Nazad</button>
              <button mat-flat-button matStepperNext class="daxa" [disabled]="generalInfoContactDetailFormGroup.invalid">Dalje</button>
            </div>
          </form>
        </mat-card-content>
      </mat-card>
    }
  </mat-step>


  <!-- Step 3: Achievements Information -->
  <mat-step [stepControl]="achievementsFormGroup">
    <ng-template matStepLabel>2. Postignuća i rezultati</ng-template>
    @if (stepper.selectedIndex === 2) {
      <mat-card class="daxa-card mb-25 border-radius bg-white border-none d-block">
        <mat-card-header>
          <mat-card-title>
            <h5 class="mb-0">2. Postignuća i rezultati</h5>
          </mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <form [formGroup]="achievementsFormGroup">
            @for (field of [
              { label: 'Opišite u kojoj su mjeri ciljevi programa/projekta ostvareni (sukladno prijedlogu programa/projekta za koji su odobrena bespovratna sredstva).', control: 'achievementDescription', type: 'text' },
              { label: 'Korisnici obuhvaćeni programom/projektom (spol, dob, mjesto odakle su korisnici, njihove potrebe i druge eventualne posebnosti). Na koji su način korisnici sudjelovali u projektu? Utjecaj programa/projekta na korisnike?', control: 'userImpactDescription', type: 'text' },
              { label: 'Broj korisnika obuhvaćenih programom/projektom.', control: 'numberOfUsers', type: 'number' },
              { label: 'Ako je bilo odstupanja u odnosu na prijedlog programa/projekta, navedite koji su bili razlozi, je li i na koji način ugovaratelj upoznat s promjenama, te na koji su način promjene utjecale na rezultate i ciljeve programa/projekta?', control: 'deviationReason', type: 'text' },
              { label: 'Jeste li u izvještajnom razdoblju naišli na neke značajne prepreke u provedbi programa/projekta? Ako da, kako ste ih uspjeli prevladati?', control: 'projectObstacles', type: 'text' }
              ]; track field) {
              <div>
                <div class="mb-25">
                  @if (field.type === 'text') {
                    <mat-form-field class="full-width">
                      <mat-label>{{ field.label }}</mat-label>
                      <textarea matInput [formControlName]="field.control"></textarea>
                    </mat-form-field>
                  }
                  @if (field.type === 'number') {
                    <mat-form-field class="full-width">
                      <mat-label>{{ field.label }}</mat-label>
                      <input matInput type="number" [formControlName]="field.control" />
                    </mat-form-field>
                  }
                </div>
              </div>
            }
            <div>
              <button mat-flat-button matStepperPrevious class="mr-15">Nazad</button>
              <button mat-flat-button matStepperNext class="daxa" [disabled]="achievementsFormGroup.invalid">Dalje</button>
            </div>
          </form>
        </mat-card-content>
      </mat-card>
    }
  </mat-step>

  <!-- Step 4: Program Executors -->
  <mat-step [stepControl]="executorsFormGroup">
    <ng-template matStepLabel>3. Provoditelji programa/projekta</ng-template>
    @if (stepper.selectedIndex === 3) {
      <mat-card class="daxa-card mb-25 border-radius bg-white border-none d-block">
        <mat-card-header>
          <mat-card-title>
            <h5 class="mb-0">3. Provoditelji programa/projekta</h5>
          </mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <form [formGroup]="executorsFormGroup">
            @for (field of [
              { label: 'Navedite broj zaposlenih uključenih u provedbu programa/projekta.', control: 'numberOfEmployees', type: 'number', config: { decimals: 0, useThousands: true, maxDigits: 10 } },
              { label: 'Navedite broj volontera uključenih u provedbu programa/projekta.', control: 'numberOfVolunteers', type: 'number', config: { decimals: 0, useThousands: true, maxDigits: 10 } },
              { label: 'Jesu li zaposlene nove osobe za potrebe provedbe programa/projekta?', control: 'newEmployees', type: 'checkbox' },
              { label: 'U kojim su aktivnostima sudjelovali volonteri na programu/projektu?', control: 'volunteerActivities', type: 'text' },
              { label: 'Je li bilo promjena vezano uz osobe koje su sudjelovale u provedbi programa/projekta u odnosu na prijedlog programa/projekta? Ako da, ukratko obrazložite razloge.', control: 'personnelChangesReason', type: 'text' }
              ]; track field) {
              <div>
                <div class="mb-25">
                  @if (field.type === 'text') {
                    <mat-form-field class="full-width">
                      <mat-label>{{ field.label }}</mat-label>
                      <textarea matInput [formControlName]="field.control"></textarea>
                    </mat-form-field>
                  }
                  @if (field.type === 'number') {
                    <mat-form-field class="full-width">
                      <mat-label>{{ field.label }}</mat-label>
                      <input matInput formattedNumber [config]="field.config" [formControlName]="field.control" />
                    </mat-form-field>
                  }
                  @if (field.type === 'checkbox') {
                    <mat-checkbox [formControlName]="field.control">
                      {{ field.label }}
                    </mat-checkbox>
                  }
                </div>
              </div>
            }
            <div>
              <button mat-flat-button matStepperPrevious class="mr-15">Nazad</button>
              <button mat-flat-button matStepperNext class="daxa" [disabled]="executorsFormGroup.invalid">Dalje</button>
            </div>
          </form>
        </mat-card-content>
      </mat-card>
    }
  </mat-step>

  <!-- Step 5: Program Executors (Budget) -->
  <mat-step [stepControl]="budgetFormGroup">
    <ng-template matStepLabel>4. Proračun programa/projekta</ng-template>
    @if (stepper.selectedIndex === 4) {
      <mat-card class="daxa-card mb-25 border-radius bg-white border-none d-block">
        <mat-card-header>
          <mat-card-title>
            <h5 class="mb-0">4. Proračun programa/projekta</h5>
          </mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <form [formGroup]="budgetFormGroup">
            @for (field of [
              { label: 'Navedite glavne napomene vezano uz financijski izvještaj i eventualno odstupanje od planiranog proračuna programa/projekta.', control: 'deviationFromPlannedBudget', type: 'text' },
              { label: 'Je li se potrošnja financijskih sredstava odvijala prema planiranom proračunu ili ste imali teškoća? Navedite teškoće na koje ste naišli.', control: 'spendingChallenges', type: 'text' },
              { label: 'Je li osigurano sufinanciranje programa/projekta?', control: 'coFinancingDetails', type: 'text' }
              ]; track field) {
              <div>
                <div class="mb-25">
                  @if (field.type === 'text') {
                    <mat-form-field class="full-width">
                      <mat-label>{{ field.label }}</mat-label>
                      <textarea matInput [formControlName]="field.control"></textarea>
                    </mat-form-field>
                  }
                </div>
              </div>
            }
            <div>
              <button mat-flat-button matStepperPrevious class="mr-15">Nazad</button>
              <button mat-flat-button matStepperNext class="daxa" [disabled]="budgetFormGroup.invalid">Dalje</button>
            </div>
          </form>
        </mat-card-content>
      </mat-card>
    }
  </mat-step>

  <!-- Step 6: Additional Details -->
  <mat-step [stepControl]="additionalDataFormGroup">
    <ng-template matStepLabel>5. Ostali podaci</ng-template>
    @if (stepper.selectedIndex === 5) {
      <mat-card class="daxa-card mb-25 border-radius bg-white border-none d-block">
        <mat-card-header>
          <mat-card-title>
            <h5 class="mb-0">5. Ostali podaci</h5>
          </mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <form [formGroup]="additionalDataFormGroup">
            @for (field of [
              { label: 'Istaknite posebne uspjehe i moguće dodatne vrijednosti vezane uz dosadašnju provedbu programa/projekta.', control: 'successStory', type: 'text' },
              { label: 'Navedite ostvarenu suradnju s medijima u proteklom razdoblju ili drugim dionicima na aktivnostima vezanim uz promociju programa/projekta ili usluga korisnicima.', control: 'mediaCollaborations', type: 'text' },
              { label: 'Što su bile glavne prepreke s kojima ste se susreli tijekom provedbe programa/projekta? Jeste li ih uspješno prevladali i kako? Što biste naveli kao glavne pouke vezano uz te prepreke i načine na koje ste ih prevladali (ili razloge koji su vas u tome spriječili)?', control: 'obstaclesAndLessons', type: 'text' },
              { label: 'Koje aktivnosti planirate u narednom razdoblju?', control: 'plannedActivitiesForNextPeriod', type: 'text' }
              ]; track field) {
              <div>
                <div class="mb-25">
                  @if (field.type === 'text') {
                    <mat-form-field class="full-width">
                      <mat-label>{{ field.label }}</mat-label>
                      <textarea matInput [formControlName]="field.control"></textarea>
                    </mat-form-field>
                  }
                </div>
              </div>
            }
            <div>
              <button mat-flat-button matStepperPrevious class="mr-15">Nazad</button>
              <button mat-flat-button matStepperNext class="daxa" [disabled]="additionalDataFormGroup.invalid">Dalje</button>
            </div>
          </form>
        </mat-card-content>
      </mat-card>
    }
  </mat-step>

  <!-- Step 7: Project activities -->
  <mat-step>
    <ng-template matStepLabel>6. Aktivnosti</ng-template>
    @if (stepper.selectedIndex === 6) {
      @if (!isLoading) {
        <app-activities
          [activitiesForm]="activitiesFormGroup">
        </app-activities>
      }
      <div>
        <button mat-flat-button matStepperPrevious class="mr-15">Nazad</button>
        <button mat-flat-button matStepperNext class="daxa">Dalje</button>
      </div>
    }
  </mat-step>

  <!-- Step 8: Attachments summary -->
  <mat-step [stepControl]="attachmentsSummaryFormGroup">
    <ng-template matStepLabel>7. Prilozi izvještaju</ng-template>
    @if (stepper.selectedIndex === 7) {
      <mat-card class="daxa-card mb-25 border-radius bg-white border-none d-block">
        <mat-card-header>
          <mat-card-title>
            <h5 class="mb-0">7. Prilozi izvještaju</h5>
          </mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <form [formGroup]="attachmentsSummaryFormGroup">
            @for (field of [
              { label: 'Popis priloga uz opisni izvještaj (zapisnici, fotografije, članci iz medija, i sl.)', control: 'attachmentsSummary', type: 'text' }
              ]; track field) {
              <div>
                <div class="mb-25">
                  @if (field.type === 'text') {
                    <mat-form-field class="full-width">
                      <mat-label>{{ field.label }}</mat-label>
                      <textarea matInput [formControlName]="field.control"></textarea>
                    </mat-form-field>
                  }
                </div>
              </div>
            }
            <div class="mb-25">
              <app-file-upload [storageLocation]="attachmentsSummaryFormGroup.get('fileStorageLocation')?.value"></app-file-upload>
            </div>
            <div>
              <button mat-flat-button matStepperPrevious class="mr-15">Nazad</button>
              <button mat-flat-button matStepperNext class="daxa">Dalje</button>
            </div>
          </form>
        </mat-card-content>
      </mat-card>
    }
  </mat-step>

  <!-- Step 9: Review and Submit -->
  <mat-step>
    <ng-template matStepLabel>8. Pregled i podnošenje</ng-template>
    @if (stepper.selectedIndex === 8) {
      <mat-card class="daxa-card mb-25 border-radius bg-white border-none d-block">
        <mat-card-header>
          <mat-card-title>
            <h5 class="mb-0">7. Pregled i podnošenje</h5>
          </mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <div class="form-actions">
            <button mat-flat-button matStepperPrevious class="mr-15">Nazad</button>
            <button mat-flat-button color="primary" (click)="onSubmit(stepper)">Spremite</button>
          </div>
        </mat-card-content>
      </mat-card>
    }
  </mat-step>

</mat-stepper>

<!-- Sticky Save Button for Both Create and Edit Modes -->
@if (!isLoading) {
  <div class="sticky-save-container">
    <button
      mat-fab
      color="primary"
      class="sticky-save-button"
      (click)="saveDescriptionReport()"
      [disabled]="isSaving"
      [matTooltip]="'Spremi promjene'">
      @if (!isSaving) {
        <mat-icon>save</mat-icon>
      }
      @if (isSaving) {
        <mat-icon class="spinning">hourglass_empty</mat-icon>
      }
    </button>
  </div>
}
